import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'; 
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from 'firebase/app-check'; // Importa getToken
import { app } from './firebaseConfig'; 

// Define your reCAPTCHA site key
const RECAPTCHA_SITE_KEY = "6LcD-7sqAAAAABOcQvLv0LWfFEJMf1BKfFol4pC3";

// Inicializa App Check
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true 
});

// Función para obtener el token de App Check
export const obtenerTokenAppCheck = async () => {
  try {
    const token = await getToken(appCheck); // Usa getToken en lugar de getAuthToken
    return token;
  } catch (error) {
    console.error('Error al obtener el token de App Check:', error);
    // Maneja el error de forma apropiada, por ejemplo, 
    // mostrando un mensaje al usuario o reintentando la operación
    return null; 
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}> 
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
        <App />
      </GoogleReCaptchaProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();